"use client";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useOrg } from "@/hooks/useOrg";
import GetStartedCard, {
  GetStartedCardType,
} from "../onboarding/GetStartedCard";

export default function GetStartedCardsGrid() {
  const { t } = useTranslation("stats");
  const { productAccess } = useOrg();

  const hasGpt = productAccess.gailGptEnabled;
  const hasAgent = productAccess.gailAgentEnabled;
  const hasBothProducts = hasGpt && hasAgent;

  return (
    <div
      className={clsx("grid", "grid-cols-1", "gap-4", {
        "lg:grid-cols-3": hasBothProducts,
        "lg:grid-cols-2": hasAgent && !hasGpt,
        "lg:grid-cols-1": hasGpt && !hasAgent,
      })}
    >
      {hasGpt && (
        <GetStartedCard
          title={t("header.chat.title")}
          description={t("header.chat.description")}
          background={{
            type: "type",
            backgroundType: GetStartedCardType.OrangePink,
          }}
          href="/gailgpt"
        />
      )}
      {hasAgent && (
        <>
          <GetStartedCard
            title={t("header.outbound.title")}
            description={t("header.outbound.description")}
            background={{
              type: "type",
              backgroundType: GetStartedCardType.BlueGreen,
            }}
            href="/outbound/campaigns"
          />
          <GetStartedCard
            title={t("header.inbound.title")}
            description={t("header.inbound.description")}
            background={{
              type: "type",
              backgroundType: GetStartedCardType.PinkOrange,
            }}
            href="/inbound/scripts"
          />
        </>
      )}
    </div>
  );
}
